const sortItems = (object, item, by)=>{
    let reordered = Object.values(object);
    by = by||"desc";
    reordered.sort(function (a, b) {
        if(by === "asc"){
            if (a[item] > b[item]) {
                return 1;
            }
            if (a[item] < b[item]) {
                return -1;
            }
            // a must be equal to b
            return 0;
        }

        if(by === "desc"){
            if (a[item] < b[item]) {
                return 1;
            }
            if (a[item] > b[item]) {
                return -1;
            }
            // a must be equal to b
            return 0;
        }        
    });

    return reordered;
}


export { sortItems }